module.exports = __webpack_public_path__ + "img/36.fadc725c.jpg";